import React from "react";

function Spiritual() {
  return (
    <div className="spritual-container">
      <div className="spt-block">
        <p>BE A SPIRITUAL SCIENTIST</p>
      </div>
      <div className="spt-block">
        <p>READ NEW AGE SPIRITUALITY BOOKS</p>
      </div>
      <div className="spt-block">
        <p>BE WITH SPIRITUAL TRIBE</p>
      </div>
      <div className="spiritual-books">
        <div>
          <div className="magazines">
            <span>Spiritual Science Magazines</span>
          </div>
          <div className="magazines">
            <span>Book List for Beginers</span>
          </div>
        </div>
        <div className="magazines-authors">
          <h5 className="text-align">Authors</h5>
          <ul>
            <li>Osho</li>
            <li>Torkom</li>
            <li>Joe Dispenza</li>
            <li>Ekchart Tolle</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Spiritual;
